import React from 'react';
import { styled, Slider } from '@teko/ds-desktop';
import { defaultSlider } from '../../constants/index.es.js';
import { getTrackingData } from '@teko/tracking';
import { HorizontalSlider } from '../HorizontalSlider/HorizontalSlider.es.js';
import { useDevice } from '../../contexts/DeviceContext.es.js';
import { ProductCard } from '../ProductCard/ProductCard.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ProductCarousel = (_a) => {
  var _b = _a, {
    products,
    productsPerRow,
    className,
    regionName,
    hideCtaButton
  } = _b, sliderSetting = __objRest(_b, [
    "products",
    "productsPerRow",
    "className",
    "regionName",
    "hideCtaButton"
  ]);
  const { isMobile } = useDevice();
  const sliderConfig = __spreadValues(__spreadProps(__spreadValues({}, defaultSlider), {
    spaceBetween: 12
  }), sliderSetting);
  if (isMobile) {
    return /* @__PURE__ */ React.createElement("div", {
      className: "wrapper-horizontal-slider"
    }, /* @__PURE__ */ React.createElement(HorizontalSlider, {
      slidesPerView: productsPerRow || 2.3,
      className: "horizontal-slider"
    }, products.map((product, index) => /* @__PURE__ */ React.createElement(ProductCard, __spreadProps(__spreadValues({
      key: index
    }, product), {
      tracking: regionName ? getTrackingData({
        regionName,
        isTrackContent: true,
        contentName: product.sku,
        target: "productDetail"
      }) : {},
      addToCart: hideCtaButton ? null : product.addToCart
    })))));
  }
  return /* @__PURE__ */ React.createElement(StyledSlider, __spreadProps(__spreadValues({}, sliderConfig), {
    slidesPerView: productsPerRow || 5,
    className
  }), products.map((item) => /* @__PURE__ */ React.createElement(Card, {
    key: item.sku
  }, /* @__PURE__ */ React.createElement(ProductCard, __spreadProps(__spreadValues({}, item), {
    tracking: getTrackingData({
      regionName,
      isTrackContent: true,
      contentName: item.sku,
      target: "productDetail"
    }),
    addToCart: hideCtaButton ? null : item.addToCart
  })))));
};
const Card = styled.div`
  background: white;
  border-radius: 0.5rem;
`;
const StyledSlider = styled(Slider)`
  .swiper-slide {
    max-width: 230px;
  }
`;

export { ProductCarousel };
